import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

export const getCJWManageHistory = async (params) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }
    let queryParams = new URLSearchParams(params).toString();

    const apiUrl = localDatabaseUrls.baseURL + localDatabaseUrls.serviceURL.cjwUploadHistory + (queryParams ? "?" + queryParams : "")

    // const apiUrl = `http://localhost:8181/costmanagement/api/v1/cjw-file/upload-history?startDate=08/27/2025&endDate=08/28/2025`;

    const response = await getAPI(apiUrl, tokenInfo);
    // await fetch(apiUrl, {
    //     method: "GET",
    //     headers: localDatabaseUrls.temp_headers
    //     // headers: {
    //     //     Authorization: 'Bearer ' + tokenInfo.id_token,
    //     //     Principal: tokenInfo.access_token,
    //     // },
    // });

    if (response.status === 200 || response.status === 201) {
        return response.json();
    } else {
        const errorData = await response.json();
        response.status !== 200 ? AlertManager.error(errorData.message, { contactSupport: false }) : AlertManager.error(response.statusText, { ContactSupport: false });
        // response.status === 404 ? AlertManager.error("File not found in bucket", { contactSupport: false }) : AlertManager.error("Error downloading file", { contactSupport: false });
        return { content: [], totalPages: 0 };
    }

};